
import { Vue, Options } from "vue-class-component";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import { CLIENT_ERROR, INTERNET_ERROR, INTERNAL_SERVER_ERROR, parsingErrorResponse } from '@/app/infrastructures/misc/Utils';
import { HangingIncomingSummary, HangingIncoming, HangingIncomingFilterRequest, FollowUpInfo, FollowUpGroup, GroupSummary, AWB, AWBSummary, FollowUpSTT } from "@/domain/entities/HangingIncoming";
import Header from "./components/header.vue";
import Filter from "./components/filter.vue";
import Actions from "./components/actions.vue";
import CardProgress from "./components/card-progress.vue";
import CardCollipsableIncoming from "./components/card-collipsable-incoming/index.vue"
import ConfirmAction from "../components/ConfirmAction.vue"
import CopyTemplate from "../components/CopyTemplate.vue"
import { SubmitHangingConfirmationUpdateStatus } from '@/data/payload/api/HangingApiRequest';
import { debounce } from 'lodash';
import { MainAppController } from "@/app/ui/controllers/MainAppController";

@Options({
  components: {
    Header,
    Filter,
    Actions,
    CardProgress,
    CardCollipsableIncoming,
    ConfirmAction,
    CopyTemplate
  }
})
class TabIncoming extends Vue {
  isLoadingFetch = false;
  isLoadingList = false;
  errorState = "";
  dataSummary = new HangingIncomingSummary()
  hangingIncomingList: HangingIncoming[] = [];
  filter = new HangingIncomingFilterRequest();
  isOpenModal = false;
  messageHtml = "";
  lastStatus = "";
  isOpenTemplate = false;
  awb: AWB[] = [];
  group: FollowUpGroup[] = [];


  async getHangingIncomingSummary() {
    try {
      this.isLoadingFetch = true;
      this.errorState = "";
      const res = await SttHangingController.getHangingIncomingSummary();
      this.dataSummary = res;
    } catch (error) {
      this._handlerError(error);
    } finally {
      this.isLoadingFetch = false;
    }
  }

  _handlerError(error: any) {
    if (!error.response) {
      this.errorState = INTERNET_ERROR;
      return;
    }
    if (error.response.status > 500) {
      this.errorState = CLIENT_ERROR;
      return;
    }
    this.errorState = INTERNAL_SERVER_ERROR;
  }

  mounted() {
    this.getHangingIncomingSummary();
    this.getHangingIncomingList(new HangingIncomingFilterRequest());
  }

  getFilter = debounce((filter: any) => {
    const params = new HangingIncomingFilterRequest({ existenceStatus: filter.existenceStatus, days: filter.days, search: filter.search, statusFollowUp: filter.statusFollowUp });
    this.filter = params;
    this.getHangingIncomingList(this.filter)
  }, 250)

  async getHangingIncomingList(params: HangingIncomingFilterRequest) {
    try {
      this.isLoadingList = true;
      const res = await SttHangingController.getHangingIncoming(params);
      this.hangingIncomingList = res;
    } catch(err) {
      this.hangingIncomingList = [];
    } finally {
      this.isLoadingList = false;
    }
  }

  get isEmptyList() {
    const isEmptyFilter = Object.values(this.filter).every(value => value === "" || value == null);
    return !this.hangingIncomingList.length && !this.isLoadingList && isEmptyFilter;
  }

  onClickTemplateMessage(hanging: HangingIncoming) {
    this.group = hanging.groups;
    this.awb = this.group.flatMap((group) => group.awbs);
    this.isOpenTemplate = true;
  }

  updateStatus(status: string) {
    this.lastStatus = status;
    this.messageHtml = this.$t("dashboard.hanging.confirmUpdateMessage", { status })
    this.isOpenModal = true
  }

  downloadHangingIncoming(listStt: []) {
    SttHangingController.downloadHangingIncoming(listStt);
  }

  onSuccessUpdateStatus() {
    this.getHangingIncomingSummary();
    this.getHangingIncomingList(this.filter);
  }

  async onUpdateStatus() {
    try {
      this.isOpenModal = false;
      MainAppController.showLoading();
      const statusUppercase = this.lastStatus.toUpperCase();
      const listStt = this.hangingIncomingList
        .flatMap(item => item.groups)
        .flatMap(group => group.awbs)
        .flatMap(awb => awb.stts)
        .filter(stt => stt.isChecked)
        .map(stt => stt.sttNo);

      const payload = new SubmitHangingConfirmationUpdateStatus({
        customProcessStatus: statusUppercase,
        sttNo: listStt,
        remarks: "Hanging",
        pageType: "hanging"
      })
      const resp = await SttHangingController.submitHangingConfirmationUpdateStatus(payload)
      const message = resp.totalSttFailed
        ? `<div class="text-base">${this.$t("dashboard.hanging.successUpdateStatusWithRatio", { status: this.lastStatus, success: resp.totalSttSuccess, total: resp.totalSttSuccess + resp.totalSttFailed })}</div>`
        : `<div class="text-base">${this.$t("dashboard.hanging.successUpdateStatus", { status: this.lastStatus })}</div>`;
      const color = resp.totalSttFailed ? '#FAB713' : '#36B37E';
      MainAppController.setSnackbarMessage(message);
      MainAppController.setSnackbarPositivity(true);
      MainAppController.setSnackbarTimeout(2000);
      MainAppController.setSnackbarBackgroundColor(color);
      MainAppController.setSnackbar(true);
      this.onSuccessUpdateStatus()
    } catch (err) {
      MainAppController.setSnackbarMessage(`<div class="text-base">${this.$t("dashboard.hanging.failUpdateStatus", { status: this.lastStatus })}</div>`);
      MainAppController.setSnackbarPositivity(false);
      MainAppController.setSnackbarTimeout(2000);
      MainAppController.setSnackbar(true);
    } finally {
      MainAppController.closeLoading();
    }
  }
}
export default TabIncoming;
